import { render, staticRenderFns } from "./SecFooter.vue?vue&type=template&id=b33c38e4&scoped=true&"
import script from "./SecFooter.vue?vue&type=script&lang=js&"
export * from "./SecFooter.vue?vue&type=script&lang=js&"
import style0 from "./SecFooter.vue?vue&type=style&index=0&id=b33c38e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33c38e4",
  null
  
)

export default component.exports